import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import type { KnowledgeResponse } from "entities/knowledge/types";
import { fetchPublicationForTopicFailure, fetchPublicationForTopicSuccess } from "entities/publication/actions";
import type { PublicationFetchForTopicAction } from "entities/publication/actionTypes";
import { getPublicationFetchParams } from "entities/publication/sagas/utils";

export function* fetchPublicationForTopicSaga(action: PublicationFetchForTopicAction) {
  const { id } = action.payload;
  try {
    const queryParams = getPublicationFetchParams(action.payload);
    const payload: KnowledgeResponse[] = yield apiFetch(`topic/${id}/publication`, {
      queryParams,
      ...(action.meta.forceRefresh
        ? {
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
            },
          }
        : {}),
    });

    yield put(fetchPublicationForTopicSuccess({ topicId: id, data: payload }, action.payload));
  } catch {
    yield put(fetchPublicationForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
